// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: white;
}
:host {
    font-family: "GothamBold", "Helvetica Neue", Helvetica,Arial, sans-serif;
}
.white-background {
    background-color: white;
    font-family:"GothamNarrowBook",Arial,sans-serif ;
  }
.content{
    font-family:"GothamNarrowBook",Arial,sans-serif ;
}
  .transparent-background {
    background-color: transparent !important;
  }
  
  .transparent-background[readonly] {
    background-color: transparent !important;
  }

.updatecontainer {
    width: 100%;
    max-width: 100%;
    background-color:whitesmoke;
    padding: 20px;
    padding-left: 50px; 
    padding-right: 50px; 
    border: 1px solid rgb(255, 252, 252);
    background-color: white;
    margin: 0px;
    border-radius: 10px;
    
}
.container{
    border:2px solid  #286090;
    margin: 0px;
    padding: 0px;
    border-radius: 5px;
    max-width: 100;
    background-color: #fff;
    padding-left: 50px;
 }
 .select-text
{
    color:white;
    background-color: #0B2D71;
    border-radius: 5px 5px 0 0;
    text-align: left;
   margin: 0;
   font-weight: bold;
   padding-left: 10px;

}
.select-text1
{
    margin-top: 10px;
    color:white;
    background-color: #0B2D71;
    border-radius: 5px 5px 0 0;
    text-align: center;
    font-weight: bold;

}

textarea
{
    height: 50px;
    max-width: 100%;
    border: none;
    background-color: transparent;
    resize: none;
    float:left;
    margin-left: 3%;
  
}
input
{
    size:"100";
    max-width: 100%;
    border: black; 
    padding-left: 30px; 
    /* margin-left: 3%;  */
}

.paddingLeft15
{
    max-width: 90%;
    border: none;
    background-color: transparent;
    resize: none;
    padding-left: 15px !important;
    margin-left: 1%;
}
.paddingLeft151
{
    max-width: 90%;
    border: none;
    background-color: transparent;
    resize: none;
    padding-left: 15px !important;
    margin-left: 1%;
   color: rgba(0, 48, 153); 
   font-size: 12;
}
 .space{
padding-left: 7%;
max-width: 90%;
    border: none;
    background-color: transparent;
    resize: none;
     box-sizing: border-box
    
 }      
 .spacing{
    padding-left: 1%; 
    padding-right: 1%;
 }

    

.boldText {
    font-weight: bold !important;
   
}
.header
{
    max-width: 100%;
    color: #fff;
    background-color: #009dd0;
    border-color: #009dd0;
    margin: 2%;
    padding: 2%;
}
.categoryName{
   
    background-color: #0B2D71;
    border-color: #0B2D71;
    padding-left: 1%;
   padding-right: 2%;
   color:#fff;
  
    
}
.button{
    align-items: center;
   
    background-color: #fff;
}
.button-upload {
    margin: 10px 15px;
    padding: 10px;
    color: rgb(245, 245, 245);
    background-color:  #286090;
    border-radius: 5px;
    width: max-content;
    font-size: 20px;
    font-family: Roboto, sans-serif;
    text-align: center;
   
} 

.loading-spinner {
    margin: auto !important;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/updatedoacategories/updatedoacategories.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;AACA;IACI,wEAAwE;AAC5E;AACA;IACI,uBAAuB;IACvB,gDAAgD;EAClD;AACF;IACI,gDAAgD;AACpD;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,wCAAwC;EAC1C;;AAEF;IACI,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,uBAAuB;IACvB,WAAW;IACX,mBAAmB;;AAEvB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;CACrB;CACA;;IAEG,WAAW;IACX,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;GACjB,SAAS;GACT,iBAAiB;GACjB,kBAAkB;;AAErB;AACA;;IAEI,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,UAAU;IACV,eAAe;;AAEnB;AACA;;IAEI,UAAU;IACV,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;IAEI,cAAc;IACd,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,6BAA6B;IAC7B,eAAe;AACnB;AACA;;IAEI,cAAc;IACd,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,6BAA6B;IAC7B,eAAe;GAChB,uBAAuB;GACvB,aAAa;AAChB;CACC;AACD,gBAAgB;AAChB,cAAc;IACV,YAAY;IACZ,6BAA6B;IAC7B,YAAY;KACX;;CAEJ;CACA;IACG,gBAAgB;IAChB,iBAAiB;CACpB;;;;AAID;IACI,4BAA4B;;AAEhC;AACA;;IAEI,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;IACV,WAAW;AACf;AACA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;GACjB,iBAAiB;GACjB,UAAU;;;AAGb;AACA;IACI,mBAAmB;;IAEnB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;;AAEtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB","sourcesContent":["body {\n    background-color: white;\n}\n:host {\n    font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica,Arial, sans-serif;\n}\n.white-background {\n    background-color: white;\n    font-family:\"GothamNarrowBook\",Arial,sans-serif ;\n  }\n.content{\n    font-family:\"GothamNarrowBook\",Arial,sans-serif ;\n}\n  .transparent-background {\n    background-color: transparent !important;\n  }\n  \n  .transparent-background[readonly] {\n    background-color: transparent !important;\n  }\n\n.updatecontainer {\n    width: 100%;\n    max-width: 100%;\n    background-color:whitesmoke;\n    padding: 20px;\n    padding-left: 50px; \n    padding-right: 50px; \n    border: 1px solid rgb(255, 252, 252);\n    background-color: white;\n    margin: 0px;\n    border-radius: 10px;\n    \n}\n.container{\n    border:2px solid  #286090;\n    margin: 0px;\n    padding: 0px;\n    border-radius: 5px;\n    max-width: 100;\n    background-color: #fff;\n    padding-left: 50px;\n }\n .select-text\n{\n    color:white;\n    background-color: #0B2D71;\n    border-radius: 5px 5px 0 0;\n    text-align: left;\n   margin: 0;\n   font-weight: bold;\n   padding-left: 10px;\n\n}\n.select-text1\n{\n    margin-top: 10px;\n    color:white;\n    background-color: #0B2D71;\n    border-radius: 5px 5px 0 0;\n    text-align: center;\n    font-weight: bold;\n\n}\n\ntextarea\n{\n    height: 50px;\n    max-width: 100%;\n    border: none;\n    background-color: transparent;\n    resize: none;\n    float:left;\n    margin-left: 3%;\n  \n}\ninput\n{\n    size:\"100\";\n    max-width: 100%;\n    border: black; \n    padding-left: 30px; \n    /* margin-left: 3%;  */\n}\n\n.paddingLeft15\n{\n    max-width: 90%;\n    border: none;\n    background-color: transparent;\n    resize: none;\n    padding-left: 15px !important;\n    margin-left: 1%;\n}\n.paddingLeft151\n{\n    max-width: 90%;\n    border: none;\n    background-color: transparent;\n    resize: none;\n    padding-left: 15px !important;\n    margin-left: 1%;\n   color: rgba(0, 48, 153); \n   font-size: 12;\n}\n .space{\npadding-left: 7%;\nmax-width: 90%;\n    border: none;\n    background-color: transparent;\n    resize: none;\n     box-sizing: border-box\n    \n }      \n .spacing{\n    padding-left: 1%; \n    padding-right: 1%;\n }\n\n    \n\n.boldText {\n    font-weight: bold !important;\n   \n}\n.header\n{\n    max-width: 100%;\n    color: #fff;\n    background-color: #009dd0;\n    border-color: #009dd0;\n    margin: 2%;\n    padding: 2%;\n}\n.categoryName{\n   \n    background-color: #0B2D71;\n    border-color: #0B2D71;\n    padding-left: 1%;\n   padding-right: 2%;\n   color:#fff;\n  \n    \n}\n.button{\n    align-items: center;\n   \n    background-color: #fff;\n}\n.button-upload {\n    margin: 10px 15px;\n    padding: 10px;\n    color: rgb(245, 245, 245);\n    background-color:  #286090;\n    border-radius: 5px;\n    width: max-content;\n    font-size: 20px;\n    font-family: Roboto, sans-serif;\n    text-align: center;\n   \n} \n\n.loading-spinner {\n    margin: auto !important;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
